import { observable } from '../lib/utils/observable.js?vue3';

export const sidebarState = observable('super_sidebar_state', {
  isCollapsed: false,
  isMobile: false,
  isIconOnly: false,
});
